import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { updateProps } from '../../../../stores/newsfeed/actions';
import { Card, CardHeader, FontIcon, CardText, Checkbox } from 'material-ui';
import LocIcon from 'material-ui/svg-icons/maps/place';
import R from 'ramda';

const Locations = props => {
  const {
    updateProp,
    expanded,
    onCardExpand,
    locations,
    savingPost,
    corporateLocSelected,
    selectedLocations,
  } = props;

  return (
    <Card
      expanded={expanded}
      onExpandChange={onCardExpand}
      style={{ boxShadow: 'none', borderBottom: '1px solid #e0e0e0', marginBottom: '4px' }}
    >
      <CardHeader actAsExpander showExpandableButton textStyle={{ display: 'none' }}>
        <div>
          <FontIcon>
            <LocIcon color={'rgba(0, 0, 0, 0.54)'} style={{ verticalAlign: 'bottom' }} />
            <span style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginLeft: '15px' }}>
              Choose Location(s)
              {selectedLocations.length > 0 && !expanded &&
                <span> - <span style={{ color: '#00bcd4' }}>{R.propOr(0, 'length', selectedLocations)} of {R.propOr(0, 'length', locations)} selected</span></span>}
            </span>
          </FontIcon>
        </div>
      </CardHeader>
      <CardText expandable style={{ padding: 0 }}>
        <div style={{ paddingLeft: '55px' }}>
          <Checkbox
            label={<div style={{ fontSize: '16px' }}>CORPORATE</div>}
            checked={corporateLocSelected}
            onCheck={() => updateProp({
              corporateLocSelected: !corporateLocSelected,
              selectedLocations: R.equals(true, corporateLocSelected) ? [] : locations.map(loc => ({ locationId: loc._id, name: loc.property_name })),
            })}
            disabled={savingPost}
          />
          {locations.map((loc, i) => {
            const checked = R.contains(loc.property_name, R.pluck('name')(selectedLocations));
            return (
              <Checkbox
                key={i}
                label={loc.property_name}
                disabled={corporateLocSelected || savingPost}
                checked={checked}
                onCheck={R.ifElse(
                  () => checked,
                    () => updateProp({ selectedLocations: R.without([{ locationId: loc._id, name: loc.property_name }], selectedLocations) }),
                  () => updateProp({
                    selectedLocations: selectedLocations.concat([{ locationId: loc._id, name: loc.property_name }]),
                    corporateLocSelected: locations.length === selectedLocations.length + 1,
                  })
                )}
              />
            );
          })}
        </div>
      </CardText>
    </Card>
  );
};

Locations.propTypes = {
  updateProp: PropTypes.func,
  expanded: PropTypes.bool,
  onCardExpand: PropTypes.func,
  locations: PropTypes.array,
  savingPost: PropTypes.bool,
  selectedLocations: PropTypes.array,
  corporateLocSelected: PropTypes.bool,
};

const mapStateToProps = ({ newsfeed, user }) => ({
  locations: user.get('mrLocations'),
  savingPost: newsfeed.get('savingPost'),
  selectedLocations: newsfeed.get('selectedLocations').toJS(),
  corporateLocSelected: newsfeed.get('corporateLocSelected'),
});

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateProps(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Locations);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/newPost/locations.jsx